export default [
  {
    name: 'analytics-dashboard',
    path: '/analytics/dashboard',
    component: () => import('@/pages/analytics/dashboard/PageAnalyticsDashboard.vue')
  },
]
